import * as cookie from 'js-cookie';

export function setSameSiteCookie(
	name: string,
	value: string | object,
	options?: cookie.CookieAttributes
) {
	cookie.set(name, value, { sameSite: 'Lax', ...options });
}
